import { useEffect, useState } from "react"
import withLoader from "../../components/layouts/WithLoader"
import UtilsUrl from "../../utils/UtilsUrl"
import ProductService from "../../services/ProductService"
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId"
import WarehouseService from "../../services/WarehouseService"
import ProductDetailsSearchWarehouse from "./table/ProductDetailsSearchWarehouse"





const ProductDetailsSearch = ({ startLoading, stopLoading }) => {


  const [product, setProduct] = useState();
  const [listProductsWarehouse, setListProductsWarehouse] = useState([]);

  useEffect(() => {

    ProductService.getProductById(getCurrentUserId(), sessionStorage.getItem("idProduct")).then((response) => {
      console.log(response.data.Product);
      setProduct(response?.data?.Product)
    }).catch((error) => {
      console.log("error", error)
    })

    startLoading();
    WarehouseService.getWarehousesBySocieteAndProduct(getCurrentUserId(), sessionStorage.getItem("idProduct")).then((response) => {
      setListProductsWarehouse(response?.data)
    }).catch((error) => {
      console.log("error", error)
    }).finally(() => {
      stopLoading();
    })


  }, [])

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">

        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-md-12">
              {/* Widget: user widget style 1 */}
              <div className="card card-widget widget-user">
                {/* Add the bg color to the header using any of the bg-* classes */}
                <div className="widget-user-header bg-gray">
                  
                  <h3 className="widget-user-username">{product && product?.productCode}-{product && product?.barcode}-{product && product?.name}</h3>
                  <h5 className="widget-user-desc">{product && product?.description}</h5>
                </div>
                {product?.imagePath && <div className="widget-user-image">
                  <img
                    alt=""
                    src={UtilsUrl.fileRetailURL() + product?.imagePath}
                    class="rounded-circle"
                    style={{ width: "100px", height: "100px" }}
                  ></img>

                </div>}

                <div className="card-footer">
                  <div className="row">
                    {/* <div className="col-sm-4 border-right">
                      <div className="description-block">
                        <h5 className="description-header">3,200</h5>
                        <span className="description-text">SALES</span>
                      </div>
                    </div>
                    <div className="col-sm-4 border-right">
                      <div className="description-block">
                        <h5 className="description-header">13,000</h5>
                        <span className="description-text">FOLLOWERS</span>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="description-block">
                        <h5 className="description-header">35</h5>
                        <span className="description-text">PRODUCTS</span>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div></div></section>

      <section className="content ">

        <div className="card">
          <div className="card-header border-0">
            <h3 className="card-title">Les dépôts</h3>
            {/* <div className="card-tools">
              <a href="#" className="btn btn-tool btn-sm">
                <i className="fas fa-download" />
              </a>
              <a href="#" className="btn btn-tool btn-sm">
                <i className="fas fa-bars" />
              </a>
            </div> */}
          </div>
          {/* <div className="card-body p-0"> */}
            {
              listProductsWarehouse.length>0 &&
              <ProductDetailsSearchWarehouse listWarehouses={listProductsWarehouse}/>
            }
            {/* <table className="table table-striped table-valign-middle">
              <thead>
                <tr>
                  <th>Dépôt</th>
                  <th>Type </th>

                  <th>Qte</th>
                  <th>Dernier Prix de vente</th>
                  <th>Dernier Prix d'achat</th>
                  <th>Transactions</th>
                </tr>
              </thead>
              <tbody>
                {
                  listProductsWarehouse.length > 0 && listProductsWarehouse.map((element, index) => (
                    <tr>
                      <td>
                       {element.warehouseName}
                      </td>
                      <td>{element.warehouseType}</td>
                      <td>{element.quantity}</td>
 <td>
     <button
            className="btn "
            onClick={(e) => {
              // sessionStorage.setItem("idProduct", cell);
            }}
          >
            <h6>
              <small>
                <i className="fas fa-search" />
              </small>
            </h6>{" "}
          </button>
                    
                      </td>
                      <td>
                         <button
            className="btn"
            onClick={(e) => {
              // sessionStorage.setItem("idProduct", cell);
            }}
          >
            <h6>
              <small>
                <i className="fas fa-search" />
              </small>
            </h6>{" "}
          </button>
                      </td>
                      <td>
                   <button
          className="btn"
          onClick={(e) => {
            localStorage.setItem('idProduct', element.productId)
            localStorage.setItem('idWarehouse', element.warehouseId)
            sessionStorage.setItem("typeDocument","Warehouse")
            window.open("/TransactionProductsDepot", "_blank");
          }}
        >
          <i class="fas fa-eye"></i>
        </button>
                      </td>
                    
                    </tr>
                  ))
                }



              </tbody>
            </table> */}
          {/* </div> */}
        </div>

      </section>


    </div>

  )
}
export default withLoader(ProductDetailsSearch)